<template>
    <div class="cell" ref="cell" :style="{width:config.width + 'px'}" v-if="config && config.visible"
         :class="[{fill, overflowed}]">
        <div class="label" v-if="inOverflowMenu">
            <template v-if="config.name">{{ config.name }}</template>
            <template v-else>{{ replaceUnderscores(field) }}</template>
        </div>
        <slot></slot>
    </div>
</template>

<script>
export default {
  name: "sc-table-cell-base",
  props: {
    field: {},
    table: {},
    inOverflowMenu: {
      default: false,
    }
  },

  data() {
    return {
      offset: 0,
    }
  },

  computed: {

    overflowed() {
      if (this.inOverflowMenu === true) {
        return false
      } else {
        return !!this.config.overflowing;
      }
    },

    config() {
      if (this.table.columns && this.table.columns[this.field]) {
        return this.table.columns[this.field]
      }
    },

    fill() {
      return !!this.config.fill;
    },

    align() {
      if (this.config.align) {
        return 'align-' + this.config.align;
      }
    }
  },

  methods: {
    replaceUnderscores(value) {
      if (value) {
        return value.replace(new RegExp('_', 'g'), ' ')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.cell {
    box-sizing: border-box;
    flex-shrink: 0;
    flex-grow: 0;

    &.overflowed {
        opacity: 0;
        pointer-events: none;
        overflow: hidden;
        height: 0;
    }
}

.cell.fill {
    flex-grow: 1;
}

.label {
    font-weight: 700;
    text-transform: capitalize;
    padding: 0 16px;
    font-size: 0.7em;
}
</style>